import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=7e144769&scoped=true"
import script from "./CustomFooter.vue?vue&type=script&lang=js"
export * from "./CustomFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e144769",
  null
  
)

export default component.exports